import React, { useEffect, useState } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { Container, Row, Col } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import QuestsBlogCard from './QuestsBlogCard'
import API from '../../utils/API'
import { CustomShimmerContentBlock, PageHeader } from '../common'

const QuestsLearningResourcesBlog = () => {
  const history = useHistory()
  const { questId } = useParams()
  const [isLoading, setIsLoading] = useState(true)
  const [blogs, setBlogs] = useState([])
  useEffect(() => {
    const getAllBlogCategories = async () => {
      try {
        const { data } = await API.quests.getQuestMedias(questId)
        if (data) {
          setBlogs(data.blogs || [])
          setIsLoading(false)
        } else {
          setBlogs([])
          setIsLoading(false)
        }
      } catch (e) {
        Error.showError(e)
        setIsLoading(false)
      }
    }

    getAllBlogCategories()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questId])

  return (
    <>
      <Helmet>
        <title>{`Your Experiences | Abroad`}</title>
        <meta name='title' content={`Your Experiences | Abroad`}></meta>
        <meta property='og:title' content={`Your Experiences | Abroad`}></meta>
        <meta
          property='twitter:title'
          content={`Your Experiences | Abroad`}></meta>
        <link
          rel='canonical'
          href={`${process.env.REACT_APP_DOMAIN}/quests`}></link>
        <meta
          property='og:url'
          content={`${process.env.REACT_APP_DOMAIN}/quests`}></meta>
        <meta
          property='twitter:url'
          content={`${process.env.REACT_APP_DOMAIN}/quests`}></meta>
      </Helmet>

      <PageHeader
        showBackArrow={true}
        version='small'
        backArrowAction={() => history.goBack()}
        title={'Your Experiences'}
      />
      <h1 className='s1 py-16px'>Blog</h1>

      {isLoading ? (
        <>
          <div className='mt-40px px-4'>
            <CustomShimmerContentBlock />
          </div>
          <div className='mt-40px px-4'>
            <CustomShimmerContentBlock />
          </div>
        </>
      ) : (
        <Container fluid>
          <Row className='g-0'>
            <Col className='g-0'>
              {blogs.length === 0 ? (
                <h3 className='text-center s5'>
                  There are no Blogs available at the moment. Please check back
                  later!
                </h3>
              ) : (
                blogs.map((blog) => (
                  <QuestsBlogCard blog={blog} questId={questId} />
                ))
              )}
            </Col>
          </Row>
        </Container>
      )}
    </>
  )
}

export default QuestsLearningResourcesBlog
